/**
 * Created by nijin on 31/1/17.
 */
import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'nuc-schema-tile',
    templateUrl: './schema-tile.component.html',
    styleUrls: ['./schema-tile.component.scss']
})
export class SchemaTileComponent implements OnInit {
  @Input() title;
  @Input() description;
  @Input() schema;
  @Input() isMobileApp?: boolean;
  @Input() isCheckboxVisible?: boolean;
  @Input() selectedValue?: any;
  @Input() idPrefix: string;
  @Input() index: number;
  @Output() schemaSelected: EventEmitter<any> = new EventEmitter();

  @ViewChild('preview') previewPopup;

    constructor() {
    }

    ngOnInit() {
    }

    get id(){
      return `${this.idPrefix.replace(/\s+/g, '-').toLowerCase()}-item-${this.index}`;
   }

  previewSchemaData() {
    this.previewPopup.open();
  }

  valueChanged(value) {
      this.schemaSelected.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/schema/schema-list/schema-tile.component.ts